import {connect} from '../app/connect';
import Routes from './Routes';
import LocationsThunk from '../app/thunk/locationsThunk';
import {fetchRequiredFields} from '../app/thunk/requiredfields-thunk';
import {
  fetchIssuesAction,
  fetchIssueInstanceAction,
  setPreviewIssueIdAction,
  setPreviewTemplateIdAction,
  showNewIssueModalAction,
  showNewTemplateModalAction,
  routeChangeEventTriggerAction,
  setCurrentViewAction,
  fetchCurrentUserAction,
  fetchCurrentDocsProjectAction,
  setAnalyticsId,
  registerAnalyticsMandatorySuperProps,
  setAnalyticsMandatoryPeopleProps,
  setAnalyticsPeopleProps,
  setQueryParamsFromUrlAction,
  setPackageDeepLinkingFalse,
  fetchIssuesCustomizationMetadata,
  showNewIssueAttributeModalAction,
  editIssueAttribute,
  resetEditingIssueAttributeId,
  fetchIssuesPermissions,
  fetchIssueRootCausesAction
} from '../app/actions';

import {
  isIssuesEnabled,
  isQualityIssuesEnabled,
  getCurrentViewType,
  getCurrentUserId,
  getIsLoadingCurrentUserPermissions,
  getOxygenMappings,
  getCurrentProject,
  getRegion,
  getAnalyticsId,
  getAnalyticsHostingAppName,
  getIsPackageDeepLinking,
  isFieldIssuesCustomizationDataFetched,
  isIssueRootCausesDefinitionsFetched
} from '../app/selectors';
import {fetchActiveTemplatesAction, fetchIssueTemplateCategoriesAction} from '../app/templates/templates-actions';

const mapStateToProps = state => ({
  isIssuesEnabled: isIssuesEnabled(state),
  isQualityIssuesEnabled: isQualityIssuesEnabled(state),
  currentView: getCurrentViewType(state),
  currentUserId: getCurrentUserId(state),
  isLoadingCurrentUserPermissions: getIsLoadingCurrentUserPermissions(state),
  currentProject: getCurrentProject(state),
  region: getRegion(state),
  oxygenMappings: getOxygenMappings(state),
  analyticsId: getAnalyticsId(state),
  analyticsHostingAppName: getAnalyticsHostingAppName(state),
  isPackageDeepLinking: getIsPackageDeepLinking(state),
  isFieldIssuesCustomizationDataFetched: isFieldIssuesCustomizationDataFetched(state),
  isIssueRootCausesDefinitionsFetched: isIssueRootCausesDefinitionsFetched(state)
});

export default connect(
  mapStateToProps,
  {
    fetchIssuesAction,
    fetchIssueInstanceAction,
    setPreviewIssueIdAction,
    setPreviewTemplateIdAction,
    showNewIssueModalAction,
    showNewTemplateModalAction,
    showNewIssueAttributeModalAction,
    editIssueAttribute,
    resetEditingIssueAttributeId,
    routeChangeEventTriggerAction,
    getDefaultLocationTree: LocationsThunk.getDefaultTree,
    setCurrentViewAction,
    fetchCurrentUserAction,
    fetchRequiredFields,
    fetchCurrentDocsProjectAction,
    setAnalyticsId,
    registerAnalyticsMandatorySuperProps,
    setAnalyticsMandatoryPeopleProps,
    setAnalyticsPeopleProps,
    setQueryParamsFromUrlAction,
    setPackageDeepLinkingFalse,
    fetchIssuesCustomizationMetadata,
    fetchIssuesPermissions,
    fetchIssueRootCausesAction,
    fetchIssueTemplateCategoriesAction,
    fetchActiveTemplatesAction
  }
)(Routes);
